import { z } from "zod";

export const IntakeSubmissionIroncladWorkflowValueSchema = z.union([
  z.object({
    key: z.string(),
    displayName: z.string(),
    type: z.literal("string"),
    value: z.string().nullable(),
  }),
  z.object({
    key: z.string(),
    displayName: z.string(),
    type: z.literal("number"),
    value: z.number().nullable(),
  }),
  z.object({
    key: z.string(),
    displayName: z.string(),
    type: z.literal("date"),
    value: z.string().nullable(),
  }),
  z.object({
    key: z.string(),
    displayName: z.string(),
    type: z.literal("duration"),
    value: z
      .object({
        years: z.number(),
        months: z.number(),
        days: z.number(),
      })
      .nullable(),
  }),
  z.object({
    key: z.string(),
    displayName: z.string(),
    type: z.literal("string"),
    value: z.string().nullable(),
  }),
  // possible attribute types: string, number, boolean, date, duration, monetaryAmount, email, address, or array
  z.object({
    key: z.string(),
    displayName: z.string(),
    type: z.literal("boolean"),
    value: z.boolean().nullable(),
  }),
  z.object({
    key: z.string(),
    displayName: z.string(),
    type: z.literal("monetaryAmount"),
    value: z
      .object({
        amount: z.number(),
        currency: z.string(),
      })
      .nullable(),
  }),
  z.object({
    key: z.string(),
    displayName: z.string(),
    type: z.literal("email"),
    value: z.string().nullable(),
  }),
  z.object({
    key: z.string(),
    displayName: z.string(),
    type: z.literal("address"),
    value: z
      .object({
        lines: z.string().array(),
        locality: z.string(),
        region: z.string(),
        postcode: z.string(),
        country: z.string(),
      })
      .nullable(),
  }),
  z.object({
    key: z.string(),
    displayName: z.string(),
    type: z.literal("document"),
    value: z
      .object({
        id: z.string(),
        name: z.string(),
        displayName: z.string(),
        mimeType: z.string(),
      })
      .nullable(),
  }),
  z.object({
    key: z.string(),
    displayName: z.string(),
    type: z.literal("array"),
    value: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        displayName: z.string(),
        mimeType: z.string(),
      }),
    ),
  }),
  z.object({
    key: z.string(),
    displayName: z.string(),
    type: z.literal("object"),
    value: z.null(),
  }),
]);

export type IntakeSubmissionIroncladWorkflowValue = z.infer<
  typeof IntakeSubmissionIroncladWorkflowValueSchema
>;
